import Vue from 'vue'
import Router from 'vue-router'
import CloseBuy from '@/pages/CloseBuy';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: CloseBuy,
      beforeEnter: (to, from, next) => {
        to.query.timestamp = new Date().getTime(); // Adiciona um parâmetro de tempo
        next();
      }
    },
    {
      path: '/close-buy',
      component: CloseBuy
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js